<template>
  <div class="detail__wrap">
    <div class="detail__title">{{ title }}</div>
    <div class="detail__value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "DocuformDetailRow",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.detail {

  &__wrap {
    color: $separator_dark;
    line-height: 1;

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  &__title {
    color: $separator_dark;
    margin-bottom: 7px;
    font-size: 12px;
  }

  &__value {
    color: $buttonBlackTextColor;
    font-size: 13px;
  }
}

</style>
